import { Dispatch } from "react";
import { Types } from "./FormacionDesarrolloContext";

export const createCoursesModal = (_id = "", createModalCourse = true, dispatch: Dispatch<any>):void =>{
    dispatch({
        type: Types.CREATE_COURSE,
        payload:{
            _id,
            createModalCourse
        }
    })
}

export const deleteCoursesModal = (_id="", deleteModalCourse = true, dispatch: Dispatch<any>):void =>{
    dispatch({
        type: Types.DELETE_COURSE,
        payload:{
            _id,
            deleteModalCourse
        }
    })
}

export const clearCoursesModal = ({_id="", createModalCourse = false, deleteModalCourse=false, updateModalCourse=false}:any, dispatch: Dispatch<any>):void =>{
    dispatch({
        type: Types.CLEAR_COURSE,
        payload:{
            _id,
            createModalCourse,
            deleteModalCourse,
            updateModalCourse
        }
    })
}

export const createUserCourseModal = ({_id = "",createModalUserCourse = true}:any, dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.CREATE_USER_COURSE,
       payload:{
        createModalUserCourse
       } 
    })
}

export const closeUserCourseModal = ({_id="", createModalUserCourse = false}:any, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_USER_COURSE_MODAL,
        payload: {
            createModalUserCourse           
        }
    })
}

export const updateModalCourses = (_id = "", updateModalCourse = true, dispatch: Dispatch<any>):void => {
    dispatch({
        type:Types.UPDATE_COURSE,
        payload:{
            _id,
            updateModalCourse,
        }
    })
}